let ctx;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

export function unlockAudio() {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume();
}

// Synthesized katana slash: noise "swish" + metallic steel ring
export function playSlash(volume = 0.5) {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  const now = c.currentTime;
  const dur = 0.34;

  // Airy swish (filtered noise with a downward sweep)
  const size = Math.floor(c.sampleRate * dur);
  const buffer = c.createBuffer(1, size, c.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < size; i++) data[i] = Math.random() * 2 - 1;
  const noise = c.createBufferSource();
  noise.buffer = buffer;
  const bp = c.createBiquadFilter();
  bp.type = "bandpass";
  bp.Q.value = 1.1;
  bp.frequency.setValueAtTime(7200, now);
  bp.frequency.exponentialRampToValueAtTime(650, now + dur);
  const ng = c.createGain();
  ng.gain.setValueAtTime(0.0001, now);
  ng.gain.exponentialRampToValueAtTime(0.55 * volume, now + 0.02);
  ng.gain.exponentialRampToValueAtTime(0.0001, now + dur);
  noise.connect(bp).connect(ng).connect(c.destination);
  noise.start(now);
  noise.stop(now + dur);

  // Metallic steel ring
  const osc = c.createOscillator();
  osc.type = "triangle";
  osc.frequency.setValueAtTime(2500, now + 0.02);
  osc.frequency.exponentialRampToValueAtTime(1150, now + 0.26);
  const og = c.createGain();
  og.gain.setValueAtTime(0.0001, now + 0.02);
  og.gain.exponentialRampToValueAtTime(0.14 * volume, now + 0.04);
  og.gain.exponentialRampToValueAtTime(0.0001, now + 0.3);
  osc.connect(og).connect(c.destination);
  osc.start(now + 0.02);
  osc.stop(now + 0.3);
}
